import React from 'react';

import kaimg from '../skillicons/ka.png';
import getsuimg from '../skillicons/getsu.png';
import setsuimg from '../skillicons/setsu.png';

const iconwidth = "24"; //in pixels
const iconheight = "24";
const senwidth = "20";
const senheight = "20";

class Skill extends React.Component {
    constructor(props) {
        super(props);

    }

    render() {
        var buffs = (<span>&#8203;</span>);
        if (this.props.skill.buffs != null) { //if buffs is not null or undefined
            var bufficons = this.props.skill.buffs.map((value, key) => {
                return (
                    <span>
                        <img src={value.image} width={iconwidth} height={iconheight} class="icon" />
                    </span>
                )
            });
            var buffdurations = this.props.skill.buffs.map((value, key) => {
                if (value.duration < 10) {
                    return (
                        <span class="icontext">
                            {value.duration.toFixed(2)}
                        </span>
                    )
                }
                else {
                    return (
                        <span class="icontext">
                            {value.duration.toFixed(0)}
                        </span>
                    )
                }
            });
            buffs = (
                <div>
                    <div>
                        {bufficons}
                    </div>
                    <div>
                        {buffdurations}
                    </div>
                </div>
            )
        }

        var cooldowns = (<span>&#8203;</span>);
        if (this.props.skill.cooldowns != null) {
            var cooldownicons = this.props.skill.cooldowns.map((value, key) => {
                return (
                    <span>
                        <img src={value.image} width={iconwidth} height={iconheight} class="icon" />
                    </span>
                )
            });
            var cooldowndurations = this.props.skill.cooldowns.map((value, key) => {
                if (value.duration < 10) {
                    return (
                        <span class="icontext">
                            {value.duration.toFixed(2)}
                        </span>
                    )
                }
                else {
                    return (
                        <span class="icontext">
                            {value.duration.toFixed(0)}
                        </span>
                    )
                }
            });
            var cooldownerrors = this.props.skill.cooldowns.map((value, key) => {
                return (
                    <span class="iconerrors">
                        {value.error}
                    </span>
                )
            });
            cooldowns = (
                <div>
                    <div>
                        {cooldownicons}
                    </div>
                    <div>
                        {cooldowndurations}
                    </div>
                    <div>
                        {cooldownerrors}
                    </div>
                </div>
            )
        }

        var dots = (<span>&#8203;</span>);
        if (this.props.skill.dots != null) {
            var doticons = this.props.skill.dots.map((value, key) => {
                return (
                    <span>
                        <img src={value.image} width={iconwidth} height={iconheight} class="icon" />
                    </span>
                )
            });
            var dotdurations = this.props.skill.dots.map((value, key) => {
                return (
                    <span class="icontext">
                        {value.duration.toFixed(2)}
                    </span>
                )
            });
            dots = (
                <div>
                    <div>
                        {doticons}
                    </div>
                    <div>
                        {dotdurations}
                    </div>
                </div>
            )
        }

        var sens = [];
        if (this.props.skill.sen != null) {
            if (this.props.skill.sen.Ka === 1) {
                sens.push(<img src={kaimg} width={senwidth} height={senheight} />);
            }
            if (this.props.skill.sen.Getsu === 1) {
                sens.push(<img src={getsuimg} width={senwidth} height={senheight} />);
            }
            if (this.props.skill.sen.Setsu === 1) {
                sens.push(<img src={setsuimg} width={senwidth} height={senheight} />);
            }
        }

        let potency;
        if (this.props.skill.potency != null) {
            potency = (
                <span>
                    {this.props.skill.potency.toFixed(2)}
                </span>
            )
        }
        else {
            potency = 0;
        }

        let time;
        if (this.props.skill.time != null) {
            time = (
                <span>
                    {this.props.skill.time.toFixed(2)}
                </span>
            )
        }
        else {
            time = 0;
        }

        var id = "skillRow";
        if (this.props.skill.errorflag === true) {
            id = "skillRowError";
        }

        return (
            <li>
                <div class="col-sm-12" id={id}>
                    <div class="col-sm-5 column">
                        <div class="col-sm-2">
                            <button class="btn btn-danger" id="delete" onClick={() => { this.props.deleteRow(this.props.skill.position) }}><span class="glyphicon glyphicon-remove-circle red" aria-hidden="true"></span></button>
                        </div>
                        <div class="col-sm-2">
                            <span class="tblue">{time}</span>
                        </div>
                        <div class="col-sm-2">
                            <img src={this.props.skill.image} width={iconwidth} height={iconheight} />
                        </div>
                        <div class="col-sm-2">
                            <span class="tname">{this.props.skill.name}</span>
                        </div>
                        <div class="col-sm-2">
                            <span class="tgreen">{potency}</span>
                        </div>
                        <div class="col-sm-2">
                            <span class="tred">{this.props.skill.kenki}</span>
                        </div>
                    </div>
                    <div class="col-sm-1 column">
                        <span>{sens}</span>
                    </div>
                    <div class="col-sm-1">
                        {dots}
                    </div>
                    <div class="col-sm-3">
                        {buffs}
                    </div>
                    <div class="col-sm-2">
                        {cooldowns}
                    </div>
                </div>
            </li>
        )
    }
}

export default Skill;


// WEBPACK FOOTER //
// ./src/components/Skill.js